import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext({
  user: null,
  loading: true,
  login: () => {},
  logout: () => {},
  processSession: () => {}
});

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const AUTH_REDIRECT_URL = window.location.origin + '/';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check existing session on mount
  useEffect(() => {
    const checkSession = async () => {
      try {
        console.log('[AuthProvider] Checking existing session...');
        const response = await axios.get(`${BACKEND_URL}/api/auth/me`, {
          withCredentials: true
        });
        console.log('[AuthProvider] Session found:', response.data);
        setUser(response.data);
      } catch (error) {
        console.log('[AuthProvider] No existing session:', error.message);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, [user]);

  const login = () => {
    console.log('[AuthProvider] Redirecting to Emergent Auth...');
    console.log('[AuthProvider] Redirect URL:', AUTH_REDIRECT_URL);
    const authUrl = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(AUTH_REDIRECT_URL)}`;
    window.location.href = authUrl;
  };

  const logout = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, {
        withCredentials: true
      });
      setUser(null);
      window.location.href = '/';
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const processSession = async (sessionId) => {
    try {
      console.log('[AuthProvider] Processing session ID:', sessionId.substring(0, 20) + '...');
      console.log('[AuthProvider] Calling backend:', `${BACKEND_URL}/api/auth/session`);
      
      const response = await axios.post(
        `${BACKEND_URL}/api/auth/session`,
        {},
        {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true
        }
      );
      
      console.log('[AuthProvider] Backend response:', response.data);
      setUser(response.data.user);
      return response.data.user;
    } catch (error) {
      console.error('[AuthProvider] Session processing error:', error.response?.data || error.message);
      throw error;
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, processSession }}>
      {children}
    </AuthContext.Provider>
  );
};